import React, { useEffect, useRef, useState } from 'react';

import '../styles/gallery.css';


import garden1 from '../assets/images/Conf_hall_1.jpg';
import garden2 from '../assets/images/Conf_hall_5.jpg';
import crowd from '../assets/images/Conf_hall_3.jpg';
import garden3 from '../assets/images/Conf_hall_4.jpg';
import wedding from '../assets/images/Conf_hall_2.jpg';

const images = [garden1, garden2, crowd, garden3, wedding];

const GardenGallery = ({ language }) => {
  const scrollRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(null); // null = closed

  const scroll = (dir) => {
    scrollRef.current.scrollBy({ left: dir === 'left' ? -400 : 400, behavior: 'smooth' });
  };

  const openAt = (idx) => setCurrentIndex(idx);
  const closeModal = () => setCurrentIndex(null);
  const hasOpen = currentIndex !== null;

  const prev = (e) => {
    if (e) e.stopPropagation();
    setCurrentIndex((idx) => (idx === null ? null : (idx - 1 + images.length) % images.length));
  };
  const next = (e) => {
    if (e) e.stopPropagation();
    setCurrentIndex((idx) => (idx === null ? null : (idx + 1) % images.length));
  };

  useEffect(() => {
    if (!hasOpen) return;
    const onKey = (ev) => {
      if (ev.key === 'ArrowLeft') prev();
      else if (ev.key === 'ArrowRight') next();
      else if (ev.key === 'Escape') closeModal();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [hasOpen]);

  return (
    <section className="gallery-wrapper py-5 bg-dark text-white">
      <div className="container">
<h2 className="fw-bold mb-4 text-center text-white">
  {language === 'en' ? 'Conference Hall Gallery' : 'የኮንፈረንስ አዳራሽ ጋለሪ'}
</h2>
        <div className="gallery-scroll-wrapper">
          <button className="scroll-btn left" onClick={() => scroll('left')}>&lt;</button>
          <div className="gallery-scroll" ref={scrollRef}>
            {images.map((img, i) => (
              <div className="gallery-image-wrapper" key={i} onClick={() => openAt(i)}>
                <img src={img} className="gallery-image" alt={`hall-${i}`} />
              </div>
            ))}
          </div>
          <button className="scroll-btn right" onClick={() => scroll('right')}>&gt;</button>
        </div>
      </div>

      {hasOpen && (
        <div className="image-modal" onClick={closeModal}>
          <button className="modal-nav-btn left" onClick={prev} aria-label="Previous">&#8249;</button>
          <img src={images[currentIndex]} className="modal-img" alt={`hall-full-${currentIndex}`} />
          <button className="modal-nav-btn right" onClick={next} aria-label="Next">&#8250;</button>
          <button className="close-btn" onClick={closeModal} aria-label="Close">×</button>
        </div>
      )}
    </section>
  );
};

export default GardenGallery;
